import type { JSX } from 'react';

import { Button, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { CardCarousel } from './components/CardCarousel';
import { QRPosterCard } from './components/QRPoster/components/QRPosterCard/variant2';
import { ReadyToSharePostsCard } from './components/ReadyToSharePostsCard/variant2';
import { SocialContentCard } from './components/SocialContent/components/SocialContentCard/variant2';
import { useSharingTools } from './hooks/useSharingTools/variant2';

export function Variant2(): JSX.Element {
	const { actions } = useSharingTools();
	const items = [
		{
			key: 'ready-to-share-posts',
			component: <ReadyToSharePostsCard />,
		},
		{
			key: 'social-content',
			component: <SocialContentCard />,
		},
		{
			key: 'qr-poster',
			component: <QRPosterCard />,
		},
	];
	return (
		<div className="flex w-full flex-col gap-5 overflow-x-visible py-8 md:px-12 md:py-12">
			<div className="flex flex-row items-center justify-between px-4 md:px-0">
				<Text variant="heading" size="small">
					<Translate value="corgi.petition.starter_dashboard_v2.sharing_tools.title" />
				</Text>
				<Button data-qa="all-tools-button" variant="tertiary" size="small" onClick={actions.navigateToAllTools}>
					<Translate value="corgi.petition.starter_dashboard_v2.sharing_tools.all_tools" />
				</Button>
			</div>
			<CardCarousel items={items} />
		</div>
	);
}
